export type FeatureHistogram = ContinuousHistogram | DiscreteHistogram;

export interface ContinuousHistogram {
  bins: ContinuousHistogram.Bin[];
}

export namespace ContinuousHistogram {
  export interface Bin {
    l: number;
    u: number;
    frequency: number;
  }

  export function isTypeOf(
    histogram: FeatureHistogram
  ): histogram is ContinuousHistogram {
    const bin = histogram.bins[0];
    return bin && 'l' in bin && 'u' in bin;
  }
}

export interface DiscreteHistogram {
  bins: DiscreteHistogram.Bin[];
}

export namespace DiscreteHistogram {
  export interface Bin {
    label: number;
    frequency: number;
  }

  export function isTypeOf(
    histogram: FeatureHistogram
  ): histogram is DiscreteHistogram {
    const bin = histogram.bins[0];
    return bin && 'label' in bin;
  }
}
